import { AssessmentProgress } from "@/schema/AssessmentProgress";
import { atom, useAtomValue, useSetAtom } from "jotai";

type DialogAtom = {
  assessment?: AssessmentProgress;
  type: "" | "confirm";
};

const dialogAtom = atom<DialogAtom>({
  assessment: undefined,
  type: "",
});

const assessmentAtom = atom((get) => get(dialogAtom).assessment);
const typeAtom = atom((get) => get(dialogAtom).type);

function useAssessmentDialog() {
  const setDialog = useSetAtom(dialogAtom);
  const assessment = useAtomValue(assessmentAtom);
  const type = useAtomValue(typeAtom);
  const resetDialog = () => setDialog({ assessment: undefined, type: "" });

  return {
    type,
    assessment,
    setDialog,
    resetDialog,
  };
}

export default useAssessmentDialog;
